import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ImageMosaic from "./components/ImageMosaic";
import hardcodedImages from "./images";

const ImageGallery = ({ images: propImages }) => {
  const elementsRef = useRef([]);
  const navigate = useNavigate();

  // Use Sanity-fetched images if provided, otherwise fall back to hardcoded
  const images = propImages || hardcodedImages;

  useEffect(() => {
    const elements = elementsRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach((element) => {
      if (element) {
        element.classList.add('hidden');
        observer.observe(element);
      }
    });

    return () => {
      elements.forEach((element) => {
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, []);

  const handleClick = (slug) => {
    navigate(`/projects/${slug}`);
  };

  return (
    <>
      <ImageMosaic
        images={images}
        handleClick={(e, { index }) => {
          const projectSlug = images[index].slug;
          handleClick(projectSlug);
        }}
        elementsRef={elementsRef}
      />
    </>
  );
};

export default ImageGallery;
